export const formLabelLocale = {
    optional: '(optional)',
};
//# sourceMappingURL=FormLabel.locale.js.map